import React, { useEffect } from 'react';
import { Modal } from 'antd';
import css from './index.module.scss';
import { CloseIcon } from '@/components/UI/svg/Ecocredits';

interface props {
    children: React.ReactElement;
    closeModal: () => void;
    style?: React.CSSProperties;
    visible: boolean;
    className?: string;
    zIndex?: number;
    afterOpen?: () => void;
}

const EcoModal: React.FC<props> = ({ children, closeModal, style, visible, className = '', zIndex = 1200, afterOpen }) => {
    useEffect(() => {
        if (visible) afterOpen?.();
    }, [visible]);

    return (
        <Modal
            width={980}
            bodyStyle={style}
            className={`${css.modal} ${className}`}
            open={visible}
            visible={visible}
            closable={false}
            footer={null}
            zIndex={zIndex}
        >
            <div className="modal-header">
                <span onClick={closeModal} className="icon">
                    <CloseIcon />
                </span>
            </div>
            <div className="modal-content">{children}</div>
        </Modal>
    );
};

export default EcoModal;
